var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "main_form" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: { inline: true, model: _vm.queryModel, size: "small" }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("m.audit_status"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.queryModel.state,
                        callback: function($$v) {
                          _vm.$set(_vm.queryModel, "state", $$v)
                        },
                        expression: "queryModel.state"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: 0, label: _vm.$t("m.pending_review") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 1, label: _vm.$t("m.approved") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 2, label: _vm.$t("m.not_approved") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 3, label: _vm.$t("m.have-expired") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          value: 7,
                          label: _vm.$t("m.System_automatically_through")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.createStartTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "createStartTime", $$v)
                          },
                          expression: "queryModel.createStartTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "coldiv", attrs: { span: 1 } }, [
                    _vm._v("~")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.createEndTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "createEndTime", $$v)
                          },
                          expression: "queryModel.createEndTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onQueryBtnClick }
                },
                [_vm._v(_vm._s(_vm.$t("m.search")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v(_vm._s(_vm.$t("m.reset")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table"
                }
              ],
              ref: "tableOrder",
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-class-name": _vm.tableRowClassName,
                "element-loading-text": "",
                "element-loading-spinner": "el-icon-loading"
              }
            },
            [
              _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userId", label: _vm.$t("m.live_ID") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userNickName",
                  label: _vm.$t("m.sereamer_nickname")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "reason", label: _vm.$t("m.Transfer-grounds") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: _vm.$t("m.apply_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: _vm.$t("m.audit_status") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.state == 0
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.pending_review")))
                            ])
                          : scope.row.state == 1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.approved")))])
                          : scope.row.state == 2
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.not_approved")))
                            ])
                          : scope.row.state == 3
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.have-expired")))
                            ])
                          : scope.row.state == 7
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.System_automatically_through"))
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dealTime",
                  label: _vm.$t("m.approval-time"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.dealTime
                          ? _c("span", [_vm._v(_vm._s(scope.row.dealTime))])
                          : _c("span", [_vm._v("---")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rejectReason",
                  label: _vm.$t("m.rejection_reason")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.rejectReason
                          ? _c("span", [_vm._v(_vm._s(scope.row.rejectReason))])
                          : _c("span", [_vm._v("---")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "useLang", label: _vm.$t("m.mastery_lang") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("m.oper"), width: "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row.state === 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.passApplication(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.pass")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectCooperation(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.refused")))]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryModel.page,
              "page-sizes": [10, 20, 30, 100, 300, 500],
              "page-size": _vm.queryModel.limit,
              small: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.queryModel.total,
              "pager-count": 5
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onCurrentPageChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("transfer-audit-dialog", {
        ref: "transferAudit",
        on: { affirm: _vm.affirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a83f9aee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a83f9aee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/anchor/transferAuditPage.vue
// module id = null
// module chunks = 